export type FounderStatus = 'founder' | 'co_founder' | 'team_member';

export const FOUNDER_STATUS_OPTIONS: { value: FounderStatus; label: string }[] = [
  { value: 'founder', label: 'Founder' },
  { value: 'co_founder', label: 'Co-founder' },
  { value: 'team_member', label: 'Team member' },
];

export function accessRoleForFounderStatus(fs: FounderStatus): 'owner' | 'member' {
  return fs === 'team_member' ? 'member' : 'owner';
}

export function canCreateOrClaim(fs: FounderStatus): boolean {
  return fs === 'founder' || fs === 'co_founder';
}
